import { render } from "./normgroupsview.vue?vue&type=template&id=3eab43ae"
import script from "./normgroupsview.vue?vue&type=script&lang=js"
export * from "./normgroupsview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__